// Centralised default profile picture.
//
// Use this everywhere a user's profile picture is rendered so broken /
// empty URLs gracefully fall back to a neutral avatar instead of an empty
// circle or a broken image icon.
//
// `resolveProfilePic(url)` — pick a safe URL for the <img src>.
// `handleProfilePicError(event)` — attach as the <img> onError prop so
// URLs that resolve but fail to load (expired Google profile URLs,
// blocked cross-origin, etc.) also fall back.
//
// Keep this file tiny and dependency-free — it is imported by many
// components.

export const DEFAULT_PROFILE_PIC =
  'https://images.unsplash.com/photo-1623594675959-02360202d4d6?crop=entropy&cs=srgb&fm=jpg&w=150&q=85';

const getAppOrigin = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.trim()) {
    return envUrl.trim().replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return '';
};

export const resolveProfilePic = (url) => {
  if (typeof url !== 'string' || url.trim().length === 0) return DEFAULT_PROFILE_PIC;

  const cleaned = url.trim();
  if (/^(https?:|data:image\/|blob:)/i.test(cleaned)) return cleaned;

  // Some backend records may store an upload as a relative path. Resolve it
  // against the app/backend origin so <img> receives a loadable absolute URL.
  if (cleaned.startsWith('/')) return `${getAppOrigin()}${cleaned}`;
  return `${getAppOrigin()}/${cleaned}`;
};

export const isDefaultProfilePic = (url) => resolveProfilePic(url) === DEFAULT_PROFILE_PIC;


export const handleProfilePicError = (event) => {
  const el = event?.currentTarget;
  if (!el) return;
  if (el.src === DEFAULT_PROFILE_PIC) return; // avoid infinite loop if fallback itself errors
  el.src = DEFAULT_PROFILE_PIC;
};
